export default {
  AddIntrestAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addintrest", payload)
      resolve()
    })
  }
}
